import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { LocaleService, SUPPORTED_LOCALE } from 'src/app/services/locale.service';

export interface CountrySwitchDialogData {
  recommendedLocale: SUPPORTED_LOCALE;
}

@Component({
  selector: 'app-country-switch-dialog',
  templateUrl: './country-switch-dialog.component.html',
  styleUrls: ['./country-switch-dialog.component.scss'],
  imports: [MatButtonModule, MatDialogModule],
})
export class CountrySwitchDialogComponent {
  private readonly localeService: LocaleService = inject(LocaleService);
  readonly breakpointService: BreakpointService = inject(BreakpointService);
  data = inject<CountrySwitchDialogData>(MAT_DIALOG_DATA);
  message: string;

  constructor() {
    this.message = this.setMessage();
  }

  onChangeLocale() {
    this.localeService.changeLocale(this.data.recommendedLocale);
  }

  private setMessage(): string {
    const locale = new Intl.Locale(this.data.recommendedLocale);
    switch (locale.region) {
      case 'US':
        return `It looks like you're in the United States. Would you like to switch to our US site?`;
      case 'CA':
        return `It looks like you're in Canada. Would you like to switch to our Canadian site?`;
      default:
        return "We weren't sure which country you are in. Would you like to switch to the recommended site?";
    }
  }
}
